import { SERVER_URL } from "../config/backend";
import moment from "moment";

export async function News() {
    var result = [];
    var queryNews = `query News($skip:Int!,$take:Int!,$report:Boolean!){
        news(skip:$skip, take:$take,report:$report){
            status,
            errors{
                field,
                messages
            },
            objects{
                id,
                title,
                isActive,
                dateAndTime,
                endDatetime,
                image{
                    name,
                    url,
                    extension
                }
            }
        }
    }`;

    await fetch(`${SERVER_URL}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
            Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            language: "en",
        },
        body: JSON.stringify({
            operationName: "News",
            query: queryNews,
            variables: {
                skip: 1,
                take: 100,
                report: true,
            },
        }),
    })
        .then((r) => r.json())
        .then((data) => {
            result["status"] = data["data"]["news"]["status"];
            result["errors"] = data["data"]["news"]["errors"];
            result["news"] = data["data"]["news"]["objects"];
        });

    if (result["news"].length > 0) {
        return result["news"];
    } else {
        return [];
    }
}

export async function LastNew(globalLang) {
    var result = [];
    var queryNews = `query News($skip:Int!,$take:Int!,$report:Boolean!){
        news(skip:$skip, take:$take,report:$report){
            status,
            errors{
                field,
                messages
            },
            objects{
                id,
                title,
                isActive,
                dateAndTime,
                endDatetime,
                image{
                    name,
                    url,
                    extension,
                    description
                },
                content
            }
        }
    }`;

    await fetch(`${SERVER_URL}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
            Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            language: globalLang,
        },
        body: JSON.stringify({
            operationName: "News",
            query: queryNews,
            variables: {
                skip: 1,
                take: 100,
                report: true,
            },
        }),
    })
        .then((r) => r.json())
        .then((data) => {
            result["status"] = data["data"]["news"]["status"];
            result["errors"] = data["data"]["news"]["errors"];
            result["news"] = data["data"]["news"]["objects"];
        });

    if (result["news"].length > 0) {
        // let cant = result["news"].length;
        // return result["news"][cant - 1];
        return result["news"];
    } else {
        return [];
    }
}

export async function History(globalLang) {
    var result = [];
    var queryHotelHistory = `query hotel_history{
        hotelHistory{
            hotelHistory,
            blogUrl,
            blogDescription,
            personalities{
                id,
                name,
                description,
                decade,
                photo,
            },
            gallery{
                images{
                    name,
                    extension,
                    path,
                    url,
                    description,
                }
            }
        }
    }`;

    await fetch(`${SERVER_URL}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
            Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            language: globalLang,
        },
        body: JSON.stringify({
            operationName: "hotel_history",
            query: queryHotelHistory,
        }),
    })
        .then((r) => r.json())
        .then((data) => {
            result = data["data"]["hotelHistory"];
        });
    return result;
}

export async function GetParisien(globalLang) {
    var texto1 = "";
    var texto2 = "";
    var imagen = "";
    var queryParisient = `query parisien{
        parisien{
            status,
            object{
                id,
                name,
                mainImage{
                    path,
                    extension,
                    url
                },
                image1{
                    name,
                    extension,
                    url,
                    description
                },
                image2{
                    name,
                    extension,
                    url,
                    description
                },
                image3{
                    name,
                    extension,
                    url,
                    description
                },
                image4{
                    name,
                    extension,
                    url,
                    description
                },
                price,
                priceWithFood,
                importantInformation,
                poeticDescription,
                schedule{
                    days{
                        day,
                        open,
                        close
                    }
                }      
            }
        }
    }`;

    await fetch(`${SERVER_URL}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
            Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            language: globalLang,
        },
        body: JSON.stringify({
            operationName: "parisien",
            query: queryParisient,
        }),
    })
        .then((r) => r.json())
        .then((response) => {
            var parisien = response["data"]["parisien"]["object"];
            // texto1 = parisien["poeticDescription"];
            texto2 = parisien["importantInformation"];
            imagen = parisien.mainImage.url;
        });

    return { texto: texto1 + " " + texto2, imagen: imagen };
}

export async function Promociones(globalLang) {
    var result = [];
    var queryPromociones = `query promociones($skip:Int!,$take:Int!,$report:Boolean!){
        offers(skip:$skip, take:$take,report:$report){
            status,
            errors{
                field,
                messages
            },
            objects{
                offer,
                endDate,
                price,
                description,
                place {
                    id
                },
                photo{
                    path,
                    extension,
                    url
                }
            }
        }
    }`;

    await fetch(`${SERVER_URL}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
            Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            language: globalLang,
        },
        body: JSON.stringify({
            operationName: "promociones",
            query: queryPromociones,
            variables: {
                skip: 1,
                take: 100,
                report: true,
            },
        }),
    })
        .then((r) => r.json())
        .then((data) => {
            let status = data["data"]["offers"]["status"];
            if (status === 200) {
                for (const iterator of data["data"]["offers"]["objects"]) {
                    if (result.length === 0) {
                        result = iterator;
                    } else {
                        if (moment(result.endDate) > moment(iterator.endDate)) {
                            result = iterator;
                        }
                    }
                }
            }
        });
    return result;
}

export async function Notificaciones(globalLang, token) {
    var resultado = [];
    var getNotificaciones = `query getNotificaciones($skip:Int!,$take:Int!,$report:Boolean!) {
        notificationsByUser(skip:$skip, take:$take, report:$report) {
            status,
            errors{
                field,
                messages
            },
            objects{
                id,
                datetime,
                subject,
                content,
                photo{
                    url
                }
                isRead
            }
        }
    }`;

    await fetch(`${SERVER_URL}`, {
        method: "POST",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
            Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            language: globalLang,
        },
        body: JSON.stringify({
            operationName: "getNotificaciones",
            query: getNotificaciones,
            variables: {
                skip: 1,
                take: 100,
                report: true,
            },
        }),
    })
        .then((r) => r.json())
        .then((data) => {
            if (data["data"]["notificationsByUser"]) {
                if (data["data"]["notificationsByUser"]["objects"].length > 0) {
                    resultado = data["data"]["notificationsByUser"]["objects"];
                }
            }
        });
    return resultado;
}
